import { v4 as uuidv4 } from "uuid";
export class PAWorkFlowStepsModel {
    constructor() {
        this.id = uuidv4();
        this.paWorkflowId = uuidv4();
        this.paStepId = uuidv4();
        this.stepName = "";
        this.paReviewFormId = null;
        this.stepDuration = 0;
        this.paReviewFormName = "";
        this.stepOrder = 0;
        this.paStepTargetAudienceId = uuidv4();
        this.isInternalStakeholder = false;
        this.clientAssignmentApplicable = false;
    }
    durationAsString() {
        return this.stepDuration > 1 ? `${this.stepDuration} days` : `${this.stepDuration} day`;
    }
}
export default class PAWorkFlowSteps extends PAWorkFlowStepsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
